module.exports = __webpack_public_path__ + "static/sophomore-1-fde5a1ccf41a5c36e3423dd9380c670f.jpg";